import { expand } from 'uri-template-lite';
import { ClassifierFilterDto } from '../types';
import { Page, PageRequestParams } from '../../common/queryClient';
import { ClassifierOverviewDto, ClassifierSortField } from '../types';
import { apiClient } from '../../common/ApiClient';
import { ClassifierUrl } from './ClassifierUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';

type ClassifierQueryParams = ClassifierFilterDto &
  PageRequestParams<ClassifierSortField>;

const getClassifiers = (params?: ClassifierQueryParams) =>
  apiClient
    .get<Page<ClassifierOverviewDto>>(expand(ClassifierUrl.CLASSIFIER, params))
    .then((response) => response.data);

export const useListClassifiersQuery = createApiQueryHook(
  ['classifiers'],
  getClassifiers
);
